import axios from 'axios';
import config from 'api/urls-config.json';
import { API } from 'api/constants';

export const getAboutUs = () => {
    return axios.get(API + config.pages.about_us);
};
